import googlePlay from '@/assets/google-play.png';
import appStore from '@/assets/app-store.png';
import appPromoPhoto from '@/assets/person-app-usage.png';
import { hasAppStoreLink as hasResolvedAppStoreLink, resolveAppStoreUrl } from '@/lib/appStoreLinks';

interface AppDownloadSectionProps {
  config: any;
}

export function AppDownloadSection({ config }: AppDownloadSectionProps) {
  const hasGooglePlayLink = !!config.googlePlay?.url?.trim();
  const appStoreUrl = resolveAppStoreUrl(config.appStore);
  const hasAppStoreLink = hasResolvedAppStoreLink(config.appStore);

  if (!hasGooglePlayLink && !hasAppStoreLink) {
    return null;
  }

  return (
    <section className="wl6-app-download">
      <div className="wl6-container">
        <div className="wl6-app-download-inner">
          <div className="wl6-app-download-copy">
            <h2 className="wl6-app-download-title">
              Seu próximo veículo, onde você estiver
            </h2>
            <p className="wl6-app-download-lead">
              Baixe o aplicativo para explorar o estoque, salvar seus favoritos e falar com
              nossa equipe direto do celular.
            </p>
            <div className="wl6-app-download-badges">
              {hasGooglePlayLink && (
                <a
                  href={config.googlePlay.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Baixar no Google Play"
                >
                  <img src={googlePlay} alt="Disponível no Google Play" loading="lazy" />
                </a>
              )}
              {hasAppStoreLink && (
                <a
                  href={appStoreUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Baixar na App Store"
                >
                  <img src={appStore} alt="Disponível na App Store" loading="lazy" />
                </a>
              )}
            </div>
          </div>
          <div className="wl6-app-download-media">
            <img
              src={appPromoPhoto}
              alt="Aplicativo mobile"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
